export default {
  fzjn: "코스튬 스킬",
  fzda: "코스튬 프로필",
  fzpc: "코스튬 리뷰",
  djmb: "맥스 능력치",
  ydl: "조회수",
  dz: "좋아요",
  sc: "저장",
  pl: "리뷰",
  fx: "공유",
  fhsy: "홈페이지",
  xzjs: "캐릭터 선택",
  fzlh: "코스튬 일러스트",
  lhxz: "일러스트 다운로드",
  lh: "일러스트",
  dt: "큰 사이즈",
  xt: "작은 사이즈",
  gscg: "스토리 CG",
  hgddh: "호감도 연출",
  jndh: "스킬 연출",
  gjswttf: "특성 엾음",
  qhszdb: "강화 수치 대조",
  jnql: "스킬 잠재력",
  jn: "스킬 효과",
  sz: {
    qh: "강화",
    xh: "소모",
    lqsj: "쿨타임",
    jnfw: "범위",
    jnxg: "스킬 효과",
    hh: "라운드"
  },
  daxx: "프로필",
  jsyy: "대사",

  cqjy: "가챠 추천",
  qdfx: "강도 분석",
  hjfx: "용도 분석",
  zrdp: "진형 편성",
  ckgd: "더 보기",
  xppc: "취향 평가",
  jsmt: "캐릭터 이미지",
  xct: "티저 이미지",
  jsda: "캐릭터 프로필",
  srht: "생일 이미지",
  ect: "팬 아트",
  ssxfzzsxxpc: "3/4성 코스튬 리뷰 준비중",
  xggxfdwzbpcb: "일단 아래 문자 리뷰 보세요 ",
  xggxfdzhpcb: "일단 아래 종합 리뷰 보세요",
  ssxfzpc: "3/4성 코스튬 리뷰",
  sx: "속성",
  dqsz: "현재 능력치",
  fctzjpb: "서브 옵션 최적 조합",
  qhfz: "코스튬 변경",
  qhbdfz: "연동 코스튬 변경",
  ky: "각인",
  jx: "각성",
  zcjsy: "콜렉션 보너스",
  fzgynlz: "코스튬 영구 능력치",
  fzbdnlz: "코스튬 연동 능력치",
  hydjsj: "맥스 능력치",

  tf: "재능스킬",
  tfqhxg: "특성 강화 효과",
  gjszwtf: "특성 엾음",
  jsxx: "캐릭터 정보",
  zjtj: "최적 추천",
  xwtb: "하위 후보",
  jnsm: "스킬 설명",
  jnfw: "범위",
  zzjzzo: "로딩중",
  zlzskqlyrbzjj: "해당 자료 비어 있습니다. 관리자가 긴급 추가 하도록 댓글 남겨주세요",
  gjsxydlhcngko: "해당 캐릭터는 로그인 후 볼 수 있습니다~",
  dl: "로그인",
  gjsxsmrzhcngko: "해당 캐릭터는 본인 인증 후 볼 수 있습니다~",
  smrz: "본인 인증",
  ndsmxxwwcnrbfnrwfll: "본인 인증 정보는 미성년자로, 일부 내용을 볼 수 없습니다",
  tt: "메인 퀘스트 밀기",
  hjzwtjzr: "추천 진형 없음",
  bhhxh: "해당 라운드 소모",
  chjqszd: "전투 시작",
  zjsysp: "증가/잔여 SP",
  xhsp: "SP 소모",
  spbjbj: "SP 증감 없음",
  spsywf: "SP 부족",
  spszzdtzsyjnssxdds: "SP는 전투 중에 스킬을 사용 시 필요한 포인트입니다",
  mhhjssfhfsojnsxyhhzsphhfbfsp: "해당 라운드, 캐릭터가 [SP 회복] 스킬을 발동히면,다음 라운드에 총 SP가 1를 회복됩니다",
  mhhjsgjhjtsxyhhzsphhf1sp: "해당 라운드, 캐릭터가 [공격 혹은 격퇴] 시,다음 라운드에 총 SP가 1를 회복됩니다",

  qsrxydzbmc: "장비 이름 입력하세요 ",
  zyzb: "전용장비 ",
  zzzb: "제작장비",
  mszb: "마수장비",
  jbnl: "기본 능력",
  xxnl: "옵션 능력치",
  zynl: "전용 능력",
  cq: "가챠",
  gl: "확률",
  sj: "랜덤",
  x: "택",
  dj: "등급",
  yb: "일반",
  gj: "고급 ",
  zgj: "최고급",
  cs: "전설",
  scpzy: "콜렉션 보너스",
  xqcl: "필요 재료",
  jbnlms1: "기본 능력 2 중 1개를 무작위로 부여합니다. 각 옵션의 확률은 동일합니다.",
  xxnlms1:
    "3/6/9를 달성 시 생명력(N)/생명력(%)/공격력(N)/공격력(%)/치명타율(%)/치명타 피해(%)/방어력(%)/마법 저항(%) 중 하나가 무작위로 부여되며, 각 옵션의 확률은 동일합니다.",
  xxnlms2:
    "3/6/9를 달성 시 생명력(N)/생명력(%)/공격력(N)/공격력(%)/마법력(N)/마법력(%)/치명타율(%)/치명타 피해(%)/방어력(%)/마법 저항(%) 중 하나가 무작위로 부여되며, 각 옵션의 확률은 동일합니다.",

  shengxing: "승급",
  qh: "강화",
  jt: "넉백",
  gongji: "공격",
  wfzd: "전투불가",

  专用: "전용장비",
  制作: "제작장비",
  魔兽: "마수장비",

  武器: "무기 선택",
  盔甲: "갑옷 선택",
  头盔: "투구 선택",
  饰品: "장신구 선택",
  手套: "장갑 선택",

  生命力: "생명력",
  攻击力: "공격력",
  魔法力: "마법력",
  致命率: "치명확률",
  致命伤害: "치명피해",
  防御力: "방어력",
  魔法抵抗: "마법저항",
  火属性伤害: "불 속성피해",
  风属性伤害: "바람 속성피해",
  水属性伤害: "물 속성피해",
  光属性伤害: "빛 속성피해",
  暗属性伤害: "어둠 속성피해",
  火属性抵抗: "불 속성저항",
  风属性抵抗: "바람 속성저항",
  水属性抵抗: "물 속성저항",
  属性抵抗: "속성저항"
};
